import React from "react";
import { Navigate } from "react-router-dom";

const AdminHome = () => {
  return <Navigate to="/learners" />;
};

export default AdminHome;
